import { get } from 'lodash';
import { margin } from './css-utils';
import { messageWidth } from './message-defaults';
import { getBodyBorderWidth } from './get-body-border';
export const getMessageWidth = (composerData, css) => {
    const bodyBorderWidth = getBodyBorderWidth(composerData);
    const emailWidth = parseInt(get(css, 'so-global-body').maxWidth, 10) || messageWidth;
    const messageFullWidth = emailWidth - 2 * bodyBorderWidth;
    return messageFullWidth;
};
export function getContentWidth(composerData, css, rulesValues) {
    const margins = margin(rulesValues);
    const bodyBorderWidth = getBodyBorderWidth(composerData);
    const emailWidth = parseInt(get(css, 'so-global-body').maxWidth, 10) || messageWidth;
    const messageFullWidth = emailWidth -
        2 * bodyBorderWidth -
        (margins.left || 0) -
        (margins.right || 0);
    return messageFullWidth;
}
//# sourceMappingURL=get-message-width.js.map